import React from 'react';
import { WizardSourcesType } from 'components/console/elements/sideBar/WizardSourceModalType/types';
import { DatabaseForm } from 'components/console/elements/sideBar/Forms/DatabaseForm';
import { FlexContainer } from 'styles/FlexContainer';
import { Button } from 'modules/ui';
import { WizardStepComponentInterface } from 'types/global';

export const DatabaseStep = ({ onBack, onClose, projectId }: WizardStepComponentInterface<WizardSourcesType>) => {
  // TODO: We need to make a separate component for rendering loaves
  const renderFooter = (): JSX.Element => (
    <FlexContainer width="100%" justifyContent="flex-end">
      <FlexContainer gap="10px">
        <Button text="Назад" iconSize="normal" heightSize="normal" onClick={onBack} />
        <Button text="Создать" iconSize="normal" heightSize="normal" type="submit" />
      </FlexContainer>
    </FlexContainer>
  );

  return <DatabaseForm mode="add" onClose={onClose} renderFooter={renderFooter} projectId={projectId} />;
};
